module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "boxes-wrapper"
    }
  }, [_c('div', {
    staticClass: "row flex"
  }, [_vm._l((_vm.boxes), function(box, index) {
    return [(index < _vm.boxlimit && !_vm.showModal) ? _c('div', {
      key: index,
      staticClass: "box-wrapper new col-sm-4 col-xs-12"
    }, [_c('div', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport",
        value: ({}),
        expression: "{}"
      }],
      staticClass: "box",
      attrs: {
        "id": 'b' + index
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal(box)
        }
      }
    }, [(box.elements.thumbnail_video.value && !_vm.$breakpoints.isMobile()) ? _c('div', {
      staticClass: "mask-video gtm_Content-expand",
      style: ({
        'background-image': 'url(' + box.elements.thumbnail_image.value[0].url + ')',
      }),
      on: {
        "mouseover": function($event) {
          return _vm.hoverVideo($event)
        },
        "mouseleave": function($event) {
          return _vm.leaveVideo($event)
        }
      }
    }, [_c('video', {
      staticClass: "o-fit gtm_Content-expand",
      attrs: {
        "loop": "",
        "playsinline": "",
        "muted": "",
        "preload": "metadata",
        "onloadedmetadata": "this.muted = true"
      },
      domProps: {
        "muted": true
      }
    }, [_c('source', {
      attrs: {
        "src": box.elements.thumbnail_video.value,
        "type": "video/mp4"
      }
    })])]) : _c('div', {
      staticClass: "mask-image gtm_Content-expand",
      style: ({
        'background-image': 'url(' + box.elements.thumbnail_image.value[0].url + ')',
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "box-info"
    }, [_c('h3', {
      staticClass: "box-client-name"
    }, [_vm._v(_vm._s(box.elements.client.value[0].name))]), _vm._v(" "), _c('h2', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(box.elements.header_title.value))])])]) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.boxes.length > _vm.boxlimit) ? [(_vm.$route.path == '/inclusion/case-studies') ? _c('div', {
    staticClass: "load-more-container text-center col-xs-12"
  }, [_c('button', {
    staticClass: "btn_orange",
    on: {
      "click": function($event) {
        _vm.boxlimit += 8
      }
    }
  }, [_vm._v("LOAD MORE")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showViewAll) ? _c('div', {
    staticClass: "load-more-container text-center col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn_orange",
    attrs: {
      "to": "/inclusion/case-studies",
      "tag": "button"
    }
  }, [_vm._v("VIEW ALL")])], 1) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bc0d41c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/boxes-wrapper-inclusion.vue
// module id = 1500
// module chunks = 0